import { ButtonStyled, IButtonProps } from "./styles";

const Button: React.FC<IButtonProps> = (props) => (
  <ButtonStyled {...props}>{props.children}</ButtonStyled>
);

export default Button;
